// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const es: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Cómo jugar',
  'howto.pieces.heading': 'Las piezas',
  'howto.pieces.source': 'Fuente',
  'howto.pieces.mirror': 'Espejo',
  'howto.pieces.switch': 'Interruptor',
  'howto.pieces.exit': 'Salida',
  'howto.pieces.wall': 'Muro',
  'howto.controls.heading': 'Los controles',
  'howto.controls.clickSlot.line1': 'Haz clic en la casilla',
  'howto.controls.clickSlot.line2': 'coloca el espejo',
  'howto.controls.dragMirror.line1': 'Arrastra el espejo',
  'howto.controls.dragMirror.line2': 'gira',
  'howto.controls.rightClick.line1': 'Clic derecho',
  'howto.controls.rightClick.line2': 'quita el espejo',
  'howto.controls.hint': 'Rueda del ratón: giro fino de 1°.   Toca el espejo: giro de 15°.',
  'howto.objective.line1': 'Enciende cada interruptor — el cierre de la salida se abre.',
  'howto.objective.line2':
    'Después haz clic en la salida. Resuelve con los menos espejos posibles.',

  'howtoColor.title': 'Color y prismas',
  'howtoColor.pieces.heading': 'Nuevas piezas',
  'howtoColor.pieces.prism': 'Prisma',
  'howtoColor.pieces.redSwitch': 'Interruptor rojo',
  'howtoColor.pieces.yellowSwitch': 'Interruptor amarillo',
  'howtoColor.pieces.whiteSwitch': 'Interruptor blanco',
  'howtoColor.how.heading': 'Cómo funcionan',
  'howtoColor.how.line1': 'Un rayo blanco lleva luz roja, verde y azul a la vez.',
  'howtoColor.how.line2':
    'Un prisma divide la luz blanca en tres rayos de color por sus tres lados.',
  'howtoColor.how.line3': 'Haz clic en un prisma colocado para girar su cara de entrada.',
  'howtoColor.switches.line1':
    'Los interruptores muestran puntos de color — ese es el color que piden.',
  'howtoColor.switches.line2':
    'Un interruptor amarillo (puntos rojo + verde) necesita ambos colores llegando.',
  'howtoColor.switches.line3':
    'Un interruptor blanco (los tres) necesita rojo, verde Y azul a la vez.',

  'options.hints.label': 'Mostrar los ángulos de ayuda en los puzles',
  'options.hints.help': 'Muestra el ángulo entre el rayo entrante y el reflejado en cada rebote.',

  'level.01-intro.title': 'Hola, luz',
  'level.02-two-mirrors.title': 'Dos giros',
  'level.03-corner.title': 'Muro en el camino',
  'level.04-two-targets.title': 'Dos objetivos',
  'level.05-tight.title': 'Estrecho',
  'level.06-hello-color.title': 'Hola, color',
  'level.07-pick-a-side.title': 'Elige un lado',
  'level.08-yellow.title': 'Amarillo',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Espectro',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'recto',
  'puzzle.hint.angleType.acute': 'agudo',
  'puzzle.hint.angleType.obtuse': 'obtuso',
  'puzzle.hint.label': '{angle}°\n{type}',
};
